import React from 'react';
import { Car, Calendar, Eye, CheckCircle, MapPin } from 'lucide-react';
import { useAdmin } from '../context/AdminContext';
import Img from '../components/Img';
import CityFilter, { useCities, cityLabel } from '../components/CityFilter';

const PENDING_KIND_LABELS = {
  registration: null,
  vehicle_update: '🚗 Véhicule modifié — re-validation',
  vehicle_photo: '🚗 Photo de véhicule ajoutée — re-validation',
  document_update: '🪪 Pièce d\'identité / permis ajouté — re-validation',
};

export default function DriverValidationPage() {
  const { loadingDrivers, drivers, setSelectedDriver } = useAdmin();
  const [cityFilter, setCityFilter] = React.useState(''); // '' = toutes les villes
  const cities = useCities();

  if (loadingDrivers) {
    return (
      <div className="dashboard-content">
        <h1 className="page-title">Validation des chauffeurs</h1>
        <div className="loading-spinner"><div className="spinner"></div><p>Chargement des chauffeurs en attente...</p></div>
      </div>
    );
  }

  const pendingDrivers = drivers.filter(d => d.status === 'pending' && (!cityFilter || d.city_slug === cityFilter));

  return (
    <div className="dashboard-content">
      <div className="page-header">
        <h1 className="page-title">Validation des chauffeurs</h1>
        <div className="page-actions">
          <CityFilter value={cityFilter} onChange={setCityFilter} cities={cities} />
        </div>
      </div>

      {pendingDrivers.length === 0 ? (
        <div className="empty-state">
          <CheckCircle size={64} />
          <h3>Aucun chauffeur en attente{cityFilter ? ` à ${cityLabel(cities, cityFilter)}` : ''}</h3>
          <p>Tous les chauffeurs ont été traités</p>
        </div>
      ) : (
        <div className="drivers-validation-grid">
          {pendingDrivers.map(driver => (
            <div key={driver.id} className="driver-validation-card">
              <div className="driver-header">
                {driver.photo ? (
                  <Img src={driver.photo} alt={driver.name} className="driver-avatar" />
                ) : (
                  <div className="driver-avatar no-photo">{driver.name?.charAt(0)}</div>
                )}
                <div className="driver-info">
                  <h3>{driver.name}</h3>
                  <p>{driver.phone}</p>
                </div>
              </div>
              <div className="driver-vehicle">
                <Car size={20} />
                <span>{driver.vehicle?.brand} {driver.vehicle?.model}</span>
                <span className="plate-badge">{driver.vehicle?.plate}</span>
              </div>
              <div className="driver-date">
                <Calendar size={16} />
                <span>Inscrit le {new Date(driver.created_at || driver.createdAt).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="driver-date">
                <MapPin size={16} />
                <span>Ville : {cityLabel(cities, driver.city_slug)}</span>
              </div>
              {PENDING_KIND_LABELS[driver.pending_kind] && (
                <div className="driver-date" style={{ color: '#B45309', fontWeight: 600 }}>
                  <span>{PENDING_KIND_LABELS[driver.pending_kind]}</span>
                </div>
              )}
              {driver.referred_by && (
                <div className="driver-date" style={{ color: '#7C3AED', fontWeight: 600 }}>
                  <span>🤝 Parrainé par {driver.referred_by}</span>
                </div>
              )}
              <div className="driver-actions">
                <button className="btn-view" onClick={() => setSelectedDriver(driver)}>
                  <Eye size={18} /> Voir détails
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
